import { Injectable } from '@angular/core';

export interface App {
    title: string;
    description: string;
    url: string;
    icon: string;
}

@Injectable({
    providedIn: 'root',
})
export class AppConfigService {
    private readonly apps: App[] = [];

    constructor() {
        this.apps = this.parseAppsConfig();
    }

    private parseAppsConfig(): App[] {
        const appsConfigJson = `
       [
        {
            "title": "Master Data",
            "description": "Frontend for managing master data.",
            "url": "/md-fe",
            "icon": "pi pi-database"
        },
        {
            "title": "Order Management",
            "description": "Simplified orders creation and tracking.",
            "url": "/orders-fe",
            "icon": "pi pi-box"
        },
        {
            "title": "Access Control",
            "description": "Access control and user management.",
            "url": "/access-control-fe",
            "icon": "pi pi-lock"
        },
        {
            "title": "Retail Management",
            "description": "Advanced sales reporting and insights.",
            "url": "/retail-fe",
            "icon": "pi pi-chart-bar"
        },
        {
            "title": "Authentication",
            "description": "User and access management for secure operations.",
            "url": "/core-auth-fe",
            "icon": "pi pi-lock"
        },
        {
            "title": "Forecasting",
            "description": "AI-powered sales predictions and analysis.",
            "url": "/fcst-fe",
            "icon": "pi pi-chart-line"
        },
        {
            "title": "AppHub",
            "description": "Central hub for accessing various applications.",
            "url": "/",
            "icon": "pi pi-th-large"
        }
        ]

        `;
        try {
            const parsedApps: App[] = JSON.parse(appsConfigJson);
            return parsedApps.map((app) => ({
                ...app,
                url: `${window.location.origin}${app.url}`, // Prefix URL with origin
            }));
        } catch (error) {
            console.error('Failed to parse apps configuration:', error);
            return [];
        }
    }

    getApps(): App[] {
        return this.apps;
    }
}
